// removed by extract-text-webpack-plugin
module.exports = {"app":"style__app___1NkMl"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/home/style.scss
 ** module id = 361
 ** module chunks = 0
 **/